import Tippy from "@tippyjs/react";
import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";
import { ACTION_TYPE } from "../../../constants/action-enum";
import { PromotionCampaignFilter } from "./promotion-campaign-type-filter";
import { PAGE_SIZES, } from "../../../constants/status";
import { IconEye } from "../../../components/icons/icon-group";
import { PromotionCampaign } from "../../../models/response/promotion-campaign";

interface PromotionCampaignTableProps {
  tableLoading: boolean;
  data: PromotionCampaign[];
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  totalRecords: number;
  keySearch: string;
  setKeySearch: (value: string) => void;
  handleActionTypeChange: (actionType: ACTION_TYPE, item?: PromotionCampaign) => void;
}

const PromotionCampaignTable = (props: PromotionCampaignTableProps) => {
  const {
    tableLoading,
    data = [],
    page,
    pageSize,
    setPage,
    setPageSize,
    totalRecords,
    keySearch,
    setKeySearch,
    handleActionTypeChange,
  } = props;

  const [tableMaxHeight, setTableMaxHeight] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const header = document.querySelector(".navbar") as HTMLElement;
      const filter = document.getElementById("filter-bar") as HTMLElement;

      if (header && filter) {
        const headerHeight = header.offsetHeight;
        const filterHeight = filter.offsetHeight;
        const remainingHeight =
          window.innerHeight -
          headerHeight -
          filterHeight -
          24 -
          24 -
          40 -
          24;
        setTableMaxHeight(remainingHeight);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDetailClick = (item: PromotionCampaign) => {
    handleActionTypeChange(ACTION_TYPE.DETAIL, item);
  };

  return (
    <div className="panel flex flex-col gap-3">
      <PromotionCampaignFilter
        searchValue={keySearch}
        setSearchValue={setKeySearch}
      />
      <div className="datatables" style={{ height: tableMaxHeight }}>
        <DataTable
          fetching={tableLoading}
          withColumnBorders
          noRecordsText="Không có kết quả nào phù hợp với truy vấn tìm kiếm"
          highlightOnHover
          className="whitespace-nowrap table-hover custom-scroll"
          records={data}
          columns={[
            {
              accessor: "_id",
              title: "STT",
              width: "5%",
              textAlignment: "center",
              render: (record, index) => <div>{(page - 1) * pageSize + index + 1}</div>
            },
            {
              accessor: "name",
              title: "Tên loại chiến dịch khuyến mãi",
              width: "40%",
              titleClassName: "!text-center",
              render: (record) => <div className="">{record.name}</div>
            },
            {
              accessor: "description",
              title: "Mô tả",
              width: "50%",
              titleClassName: "!text-center",
              textAlignment: "left",
              render: (record) => <div className="">{record.description}</div>
            },
            {
              accessor: "action",
              title: "Action",
              titleClassName: "!text-center ",
              width: "5%",
              render: (record) => (
                <div className="flex items-center w-max mx-auto gap-2">
                  <Tippy content="Chi tiết">
                    <button type="button" data-testid="btn-detail" onClick={() => handleDetailClick(record)}>
                      <IconEye />
                    </button>
                  </Tippy>
                </div>
              ),
            },
          ]}
          totalRecords={totalRecords}
          recordsPerPage={pageSize}
          page={page}
          onPageChange={(p) => setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={setPageSize}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) =>
            `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`
          }
        />
      </div>
    </div>
  );
};

export default PromotionCampaignTable;
